import { makeStyles, Theme, createStyles } from "@material-ui/core";
export const ProfileOrderStyles = makeStyles((theme: Theme) =>
  createStyles({
    ProfileOrder: {
      "& .profileTitle": {
        textAlign: "center",
      },
    },
    table: {
      "& thead": {
        backgroundColor: "#555",
      },
      "& th": {
        color: "#fff",
        fontWeight: 600,
      },
    },
  })
);
